import {EnumModel} from 'app/shared/objects/EnumModel';
import {GridConfiguration, GridRequest} from '../../shared/grid/grid.model';
export class Venue {
  id: number;
  name: string;
  type: string;
  groupName: string;
  locationFilter: string;
  status: string;
  position: number;
  dateAdded: Date;
  durationLive: number;
  rate: number;
  totalRevenue: number;
  revenue30Days: number;
  totalCovers: number;
  covers30Days: number;
  coversPM: number;
}

export class VenueListFilterEnumsModel {
  public venueType: EnumModel[];
  public status: EnumModel[];
  public location: EnumModel[];
}


export class VenueRequestModel extends GridRequest {
  status: string;
  type: string;
  location: string;
}

export class VenueGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        dataField: 'name',
        caption: 'Venue'
      },
      'type',
      {
        dataField: 'groupName',
        caption: 'Group'
      },
      {
        dataField: 'locationFilter',
        caption: 'Location'
      },
      'status',
      {
        dataField: 'position',
        caption: 'Position',
        customizeText: function (cellInfo) {
          return cellInfo.value ? cellInfo.value.toString() : '';
        }
      },
      {
        dataField: 'dateAdded',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        align: 'right'
      },
      'durationLive',
      {
        dataField: 'rate',
        dataType: 'number',
        customizeText: function (cellInfo) {
          return '£ ' + cellInfo.value;
        }
      },
      {
        dataField: 'totalRevenue',
        dataType: 'number',
        customizeText: function (cellInfo) {
          return '£ ' + cellInfo.value;
        }
      },
      {
        dataField: 'revenue30Days',
        dataType: 'number',
        customizeText: function (cellInfo) {
          return '£ ' + cellInfo.value;
        }
      },
      'totalCovers', {
        dataField: 'covers30Days',
        caption: 'Total covers 30 days'
      },
      {
        dataField: 'coversPM',
        caption: 'Covers (P/M)',
        format: function (options) {
          if (options && options !== 0) {
            const result = Math.round(parseFloat(options) * 100) / 100;
            return result > 0 ? result.toFixed(2) : '0.00';
          }
          return '0.00';
        }
      }

    ];

    this.customSearch = [
      {
        fieldName: 'name',
        value: ''
      }
    ];

    this.selection = false;
    this.columnAutoWidth = true;
    this.sorting = {mode: 'single'};
  }


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}

export class VenueDatabaseAnalyticsModel {
  type: string;
  status: string;
  location: string;
}
export class VenueLocationListRequestModel {
  public type = null;
  public status = null;
  public location = null;
  public searchString = null;
}







// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-database/venue-database.model.ts